"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var rc_pagination_1 = tslib_1.__importDefault(require("rc-pagination"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ConfigProvider_1 = require("../ConfigProvider");
var icons_1 = require("../icons");
var Select_1 = require("../Select");
var hooks_1 = require("../utils/hooks");
function Pagination(props) {
    var onChange = props.onChange, pageSize = props.pageSize, current = props.current, _a = props.defaultCurrent, defaultCurrent = _a === void 0 ? 0 : _a, _b = props.defaultPageSize, defaultPageSize = _b === void 0 ? 10 : _b, rootHtmlProps = props.rootHtmlProps, className = props.className, style = props.style, rest = tslib_1.__rest(props, ["onChange", "pageSize", "current", "defaultCurrent", "defaultPageSize", "rootHtmlProps", "className", "style"]);
    var prefix = ConfigProvider_1.usePrefix('pagination');
    var _c = react_1.useState((current !== null && current !== void 0 ? current : defaultCurrent) + 1), innerCurrent = _c[0], setInnerCurrent = _c[1];
    var _d = react_1.useState(pageSize !== null && pageSize !== void 0 ? pageSize : defaultPageSize), innerPageSize = _d[0], setInnerPageSize = _d[1];
    hooks_1.useUpdate(function () {
        if (current != null) {
            setInnerCurrent(current + 1);
        }
        if (pageSize != null) {
            setInnerPageSize(pageSize);
        }
    }, [current, pageSize]);
    var handleChange = react_1.useCallback(function (nextPage, nextPageSize) {
        if (current == null) {
            setInnerCurrent(nextPage);
        }
        if (pageSize == null) {
            setInnerPageSize(nextPageSize);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(nextPage - 1, nextPageSize);
    }, [current, onChange, pageSize]);
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var renderSizeChanger = react_1.useMemo(function () {
        function handleSizeChange(nextPageSize) {
            handleChange(innerCurrent, nextPageSize);
        }
        // eslint-disable-next-line no-underscore-dangle
        function _renderSizeChanger(selectProps) {
            return react_1.default.createElement(SizeChanger, tslib_1.__assign({}, selectProps, { onSizeChange: handleSizeChange }));
        }
        // https://github.com/react-component/pagination/blob/0bbe863da2b1b69d048ff47604619bb65b6db611/src/Options.jsx#L110
        // eg: {value: "10", children: "10 条/页"}
        _renderSizeChanger.Option = function (optionProps) { return optionProps; };
        return _renderSizeChanger;
    }, [handleChange, innerCurrent]);
    return (react_1.default.createElement(rc_pagination_1.default, tslib_1.__assign({}, rootHtmlProps, { prefixCls: prefix, selectComponentClass: renderSizeChanger, prevIcon: react_1.default.createElement(icons_1.LeftThinIcon, null), nextIcon: react_1.default.createElement(icons_1.RightThinIcon, null), jumpPrevIcon: react_1.default.createElement(icons_1.MoreIcon, null), jumpNextIcon: react_1.default.createElement(icons_1.MoreIcon, null), pageSize: innerPageSize, 
        // 去掉 rc 默认带的 a 标签
        itemRender: function (page, type, elm) { return (type === 'page' ? page : elm); }, onChange: handleChange, current: innerCurrent, className: classnames_1.default(className, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className), style: tslib_1.__assign(tslib_1.__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style) }, rest)));
}
exports.default = Pagination;
function SizeChanger(props) {
    var value = props.value, onSizeChange = props.onSizeChange, children = props.children;
    var options = react_1.Children.map(children, function (child) {
        if (!react_1.isValidElement(child)) {
            return child;
        }
        return react_1.default.createElement(Select_1.SelectOption, { value: child.props.value }, child.props.children);
    });
    return (react_1.default.createElement(Select_1.Select, { defaultValue: value, style: { width: 'auto' }, onChange: function (size) { return onSizeChange === null || onSizeChange === void 0 ? void 0 : onSizeChange(+size); } }, options));
}
//# sourceMappingURL=index.js.map